import { getEnv, isProd } from "./env";

const AUTH_DEBUG_ENABLED = !isProd() && getEnv("VITE_AUTH_DEBUG") === "true";

type SafeErrorLike = { name?: string; message?: string; code?: string };

function safeErrorSummary(err: unknown): string {
  if (!err) return "Unknown error";
  if (typeof err === "string") return err;
  if (err instanceof Error) return err.message || err.name || "Error";
  const maybe = err as SafeErrorLike;
  return maybe.message || maybe.code || maybe.name || "Error";
}

export function authDebug(message: string) {
  if (!AUTH_DEBUG_ENABLED) return;
  // Never log tokens, accounts, redirect payloads, or raw error objects.
  // Only log the caller-provided safe message.
  // eslint-disable-next-line no-console
  console.debug(message);
}

export function authWarn(message: string) {
  if (!AUTH_DEBUG_ENABLED) return;
  // eslint-disable-next-line no-console
  console.warn(message);
}

export function authDebugError(message: string, err?: unknown) {
  if (!AUTH_DEBUG_ENABLED) return;
  // eslint-disable-next-line no-console
  console.debug(`${message}: ${safeErrorSummary(err)}`);
}
